import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-2" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table align-middle table-row-dashed fs-6 gy-1" }
const _hoisted_6 = { class: "text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, "User Id", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["onClick"]

import { ref, onMounted, provide, nextTick } from "vue";
import EditUserPermission from "./userPermissions/EditUserPermission.vue";
import SystemService from "../../services/SystemService";
import notification from "@/core/plugins/notification";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserPermission',
  setup(__props) {

const isLoading = ref(false);
const data = ref<any>([]);
const showDetail = ref(false);
const userData = ref({});
const userId = ref<any>(null);
const collapse = ref("1");
const userSelected = ref(0);
const permissionList = ref<any>([]);
const finalPermissions = ref<any>([]);
const roleList = ref<any>([]);
provide("userData", userData);
provide("permissionList", permissionList);
provide("roleList", roleList);

const tagUser = (item: any) => {
  userSelected.value = item.id;
};
const handleDetail = async (item: any) => {
  showDetail.value = false;
  await nextTick();
  collapse.value = "0";
  userSelected.value = item.id;
  showDetail.value = true;
  userData.value = item;
};

const fetchData = async () => {
  isLoading.value = true;
  try {
    const res = await SystemService.getPermissionUsers();
    const permissions = await SystemService.getPermissions();
    const roles = await SystemService.getPermissionRoles();

    permissionList.value = permissions.data;
    roleList.value = roles.data;
    data.value = res.data;

    await processPermissions();
  } catch (error) {
    console.log(error);
    notification.danger();
  }
  isLoading.value = false;
};

const processPermissions = async () => {
  finalPermissions.value = permissionList.value.map((item: any) => {
    return {
      ...item,
      type: getCategoryName(item.action, item.category),
      action: reNameAction(item.action),
    };
  });
  finalPermissions.value = finalPermissions.value.reduce((acc, item) => {
    // Remove the $ suffix for grouping
    const normalizedType = item.type.replace(/\$$/, "");

    if (!acc[normalizedType]) {
      acc[normalizedType] = [];
    }
    acc[normalizedType].push(item);
    return acc;
  }, {});

  const sortedKeys = Object.keys(finalPermissions.value).sort((a, b) =>
    a.localeCompare(b)
  );
  const sortedPermissions = {};

  for (const key of sortedKeys) {
    sortedPermissions[key] = finalPermissions.value[key];
  }

  finalPermissions.value = sortedPermissions;
};

const getCategoryName = (name: string, type: string) => {
  if (type === "API") {
    const subString = name.split("/tenant/")[1];
    return subString === undefined ? name : subString.split("/")[0];
  } else {
    return type;
  }
};

const reNameAction = (name: string) => {
  const subString = name.split("/tenant/")[1];
  return subString === undefined ? name : subString;
};

const addUser = async () => {
  isLoading.value = true;
  try {
    await SystemService.updateUserRole(userId.value, 99);
    await fetchData();
    notification.success();
  } catch (e) {
    console.log(e);
    notification.danger();
  }
  isLoading.value = false;
};

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_input, {
            clearable: "",
            modelValue: userId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userId).value = $event)),
            placeholder: "user ID",
            isLoading: isLoading.value
          }, null, 8, ["modelValue", "isLoading"]),
          _createVNode(_component_el_button, {
            type: "success",
            class: "ms-2",
            onClick: addUser
          }, {
            default: _withCtx(() => [
              _createTextVNode("Add")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_collapse, {
          modelValue: collapse.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((collapse).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse_item, {
              title: "User Permission",
              name: "1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_5, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.name")), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.email")), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.role")), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t("action.action")), 1)
                    ])
                  ]),
                  (isLoading.value)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                        _createVNode(_component_LoadingRing)
                      ]))
                    : (!isLoading.value && data.value.length == 0)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                          _createVNode(_component_NoDataBox)
                        ]))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: index,
                              class: _normalizeClass({
                  'user-select': item.id === userSelected.value,
                }),
                              onClick: ($event: any) => (tagUser(item))
                            }, [
                              _createElementVNode("td", null, _toDisplayString(item.id), 1),
                              _createElementVNode("td", null, _toDisplayString(item.firstName + " " + item.lastName), 1),
                              _createElementVNode("td", null, _toDisplayString(item.email), 1),
                              _createElementVNode("td", null, _toDisplayString(item.roles), 1),
                              _createElementVNode("td", null, [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  size: "small",
                                  onClick: ($event: any) => (handleDetail(item))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("action.detail")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ])
                            ], 10, _hoisted_11))
                          }), 128))
                        ]))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    (showDetail.value)
      ? (_openBlock(), _createBlock(EditUserPermission, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})